<template>
  <div
    :data-hue="hue"
    :data-lightness="lightness"
    :data-saturation="saturation"
    class="color">
    <div class="color-shades">
      <div
        v-for="item in shades"
        :key="item.name"
        :data-name="item.name"
        :data-gain="item.gain"
        :data-hex="item.color.hex()"
        :style="getShades(item.gain, item.color)"
        :class="`shade ${item.active}`" />
    </div>
    <div class="color-rotations">
      <div
        v-for="item in rotations"
        :key="item.name"
        :data-name="item.name"
        :data-gain="item.gain"
        :data-hex="item.color.hex()"
        :style="getRotations(item.gain, item.color)"
        :class="`rotation ${item.active}`" />
    </div>
  </div>
</template>

<script>

import color from 'onecolor'

export default {
  props: {
    color: {
      type: Object,
      default: color('#FFFFFF'),
    },
  },
  data () {
    return {
      rotations: [],
      shades: [],
      alphas: [
        { gain: 0.0, name: 'Shade-00', op: '0%' },
        { gain: 0.1, name: 'Shade-01', op: '10%' },
        { gain: 0.2, name: 'Shade-02', op: '20%' },
        { gain: 0.3, name: 'Shade-03', op: '30%' },
        { gain: 0.4, name: 'Shade-04', op: '40%' },
        { gain: 0.5, name: 'Shade-05', op: '50%' },
        { gain: 0.6, name: 'Shade-06', op: '60%' },
        { gain: 0.7, name: 'Shade-07', op: '70%' },
        { gain: 0.8, name: 'Shade-08', op: '80%' },
        { gain: 0.9, name: 'Shade-09', op: '90%' },
        { gain: 1, name: 'Shade-100', op: '100%' },
      ],
    }
  },
  computed: {
    hue () {
      return this.color.hue()
    },
    saturation () {
      return this.color.saturation()
    },
    lightness () {
      return this.color.lightness()
    },
  },
  watch: {
    color () {
      this.$emit('generateRotations', this.generateRotations(12))
      this.$emit('generateShades', this.generateShades(12))
    },
  },
  created () {
    this.$emit('generateRotations', this.generateRotations(12))
    this.$emit('generateShades', this.generateShades(12))
  },
  methods: {
    generateRotations (items) {
      let int = 1 / items
      this.rotations = []
      for (var i = 0; i < items; i++) {
        let rotation = this.color.hue() + (int * i)
        let equals = this.color.hue(rotation).equals(this.color)
        let active = equals ? 'active' : ''
        if (rotation > 1) rotation = rotation - 1
        this.rotations.push({
          name: 'rotation-' + i,
          gain: rotation,
          color: this.color.hue(rotation, true),
          active: active,
        })
        this.shades.sort(
          (a, b) => a.gain - b.gain
        )
      }
    },
    generateShades (items) {
      let int = 1 / items
      this.shades = []
      for (var i = 0; i < items; i++) {
        let rotation = this.color.lightness() + (int * i)
        let equals = this.color.lightness(rotation).equals(this.color)
        let active = equals ? 'active' : ''
        if (rotation > 1) rotation = rotation - 1
        this.logMe(i, rotation)
        this.shades.push({
          name: 'shades-' + i,
          gain: rotation,
          color: this.color.lightness(rotation),
          active: active,
        })
        this.shades.sort(
          (a, b) => a.gain - b.gain
        )
      }
    },
    getShades (gain, color) {
      let cssColor = 'color:white;'
      if (color.lightness() > 0.5) cssColor = 'color:black;'
      return 'background-color:' + color.lightness(gain).css() + ';' + cssColor
    },
    getRotations (gain, color) {
      let cssColor = 'color:white;'
      if (color.lightness() > 0.5) cssColor = 'color:black;'
      return 'background-color:' + color.hue(gain).css() + ';' + cssColor
    },
    logMe (name, event) {
      console.log(name, event)
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/mixin.scss';
.color-rotations,
.color-shades {
  display: flex;
  justify-content: flex-start;
  background-color: #3a3226;
  height: 7vh;
  width: 100%;
  .rotation,
  .shade {
    height: 100%;
    flex-grow: 1;
    transition: flex .33s ease-in-out;
    position: relative;
    font-size: .5rem;
    @include for-tablet-up {
      font-size: 1rem;
    }
    &:before {
      text-transform: uppercase;
      transition: opacity .66s ease-in-out;
      position: absolute;
      left: .2rem;
      bottom: .2rem;
      content: attr(data-hex);
      font-size: 1rem;
      opacity: 0;
    }
    &.active {
      flex-grow: 8;
      @include for-tablet-up {
        flex-grow: 3;
      }
      &:before {
        text-transform: uppercase;
        transition: opacity .66s ease-in-out;
        position: absolute;
        left: .2rem;
        bottom: .2rem;
        content: '☆';
        font-size: 1rem;
        opacity: .66;
      }
      &:hover {
        flex-grow: 8;
        @include for-tablet-up {
          flex-grow: 3;
        }
        &:before {
          opacity: 1;
          content: attr(data-hex);
        }
      }
    }
    &:hover {
      flex-grow: 8;
      @include for-tablet-up {
        flex-grow: 3;
      }
      &:before {
        opacity: 1;
      }
    }
  }
}
</style>
